/**
 * @param {string|object} key 
 * @param {string} [fallback]
 * @param {object} [values]
 */
function config(key, fallback) {
    if (typeof key === "string") {
        // return config
        return config.get(key, fallback);
    } else if (typeof key === "object") {
        // set configs
        config.set(key);
    }
}

config.configs = {};
/**
 * Check if config exists
 * @param {string} key
 * @returns {boolean}
 */
config.has = function(key) {
    var obj = config.configs;
    return key.split(".").every(function(keyPart, index, keyParts) {
        if (index === keyParts.length - 1) {
            return obj.hasOwnProperty(keyPart);
        } else {
            if (typeof obj === "object" && obj.hasOwnProperty(keyPart)) {
                obj = obj[keyPart];
                return true;
            } else {
                return false;
            }
        }
    });
}
/**
 * Set config
 * chainable
 * @param {string|object} key | key-config-pairs
 * @param {string} config
 * @returns {function} config
 */
config.set = function(key, value) {
    if (typeof key === "object") {
        var configs = key;
        Object.keys(configs).forEach(function(key) {
            config.set(key, configs[key]);
        });
    } else {
        var obj = config.configs;
        key.split(".").forEach(function(keyPart, index, keyParts) {
            if (index === keyParts.length - 1) {
                obj[keyPart] = value;
            } else {
                if (!obj.hasOwnProperty(keyPart) || typeof obj[keyPart] !== "object") {
                    obj[keyPart] = {};
                }
                obj = obj[keyPart];
            }
        });
    }
    return config;
}
/**
 * Get config
 * config.get("key") === config("key")
 * @param {string} key
 * @param {string} [fallback]
 * @returns {string}
 */
config.get = function(key, fallback) {
    if (fallback !== null && typeof fallback === "object") {
        values = fallback;
        fallback = void 0;
    }
    var obj = config.configs;
    var value = fallback || null;
    key.split(".").some(function(keyPart, index, keyParts) {
        if (index === keyParts.length - 1) {
            value = obj[keyPart];
            return true;
        } else {
            if (typeof obj === "object" && obj.hasOwnProperty(keyPart)) {
                obj = obj[keyPart];
                return false;
            } else {
                return true;
            }
        }
    });
    return value;
}

/**
 * removes given key
 * chainable
 * @param {string} key
 * @returns {function} config
 */
config.unset = function(key) {
    config.configs[key] = void 0;
    return config;
}
window.tpConfig = config.set(window.tpConfig);
export default config;